import { Tooltip, Typography } from '@mui/material';

function TextWithTooltip({ text, txtLength, txtStyle }) {
	if (text.length < txtLength) {
		return <Typography sx={txtStyle}>{text}</Typography>;
	} else {
		return (
			<Tooltip title={text} placement="bottom" arrow>
				<Typography sx={txtStyle} noWrap>
					{text.slice(0, txtLength) + '...'}
				</Typography>
			</Tooltip>
		);
	}
}

export default TextWithTooltip;
